import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Grain from "@/components/site/Grain";
import Home from "@/pages/Home";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <Grain />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0c0c0c",
              border: "1px solid rgba(255,255,255,0.15)",
              borderRadius: 0,
              color: "#f4f4f5",
              fontFamily: "JetBrains Mono, monospace",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
